import { render, staticRenderFns } from "./BuildingTestFormCard.vue?vue&type=template&id=346f0a0c&scoped=true&"
import script from "./BuildingTestFormCard.vue?vue&type=script&lang=js&"
export * from "./BuildingTestFormCard.vue?vue&type=script&lang=js&"
import style0 from "./BuildingTestFormCard.vue?vue&type=style&index=0&id=346f0a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346f0a0c",
  null
  
)

export default component.exports